<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-5">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="event => (fields['card-container'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="event => (fields['text-color'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['text-color']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Markqueue Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-markqueue']"
                    @change="event => (fields['background-markqueue'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['background-markqueue']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox v-model="fields['top-padding']" label="Padding top" :hide-details="true" class="mb-2" />
                <v-checkbox
                  v-model="fields['bottom-padding']"
                  label="Padding bottom"
                  :hide-details="true"
                  class="mb-2"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Markqueue Items</label>
          <div class="group-item">
            <div class="d-flex justify-space-between align-center">
              <div></div>
              <v-btn small text color="primary" @click="handleAddMarkqueueItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['markqueue-items']" :key="`markqueue-${i}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Markqueue {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveMarkqueueItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadMarkqueueIcon(obj, i)"
                    :image="{ imageSrc: item.icon }"
                    :height="`100`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveMarkqueueIcon(i)"
                  />
                  <v-text-field
                    :value="item.text"
                    :hide-details="true"
                    class="mt-3"
                    @input="val => handleUpdateMarkqueueText(val, i)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const getDefaultFields = () => ({
  title: 'Markqueue Kynorelle Section',
  'top-padding': true,
  'bottom-padding': true,
  'card-container': '#ffffff',
  'text-color': '#ffffff',
  'background-markqueue': '#003568',
  'markqueue-items': [{ icon: '', text: '' }],
});

export default {
  name: 'MarkqueueKynorelleSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const sectionExtract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...getDefaultFields(),
      ...sectionExtract,
      'markqueue-items':
        sectionExtract['markqueue-items'] && sectionExtract['markqueue-items'].length
          ? sectionExtract['markqueue-items'].map(item => ({
              icon: item.icon || '',
              text: item.text || '',
            }))
          : [{ icon: '', text: '' }],
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarkqueueKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadMarkqueueIcon(obj, index) {
      this.fields['markqueue-items'][index].icon = obj.imageSrc;
    },
    handleRemoveMarkqueueIcon(index) {
      this.fields['markqueue-items'][index].icon = '';
    },
    handleUpdateMarkqueueText(value, index) {
      this.fields['markqueue-items'][index].text = value;
    },
    handleAddMarkqueueItem() {
      this.fields['markqueue-items'].push({
        icon: '',
        text: '',
      });
    },
    handleRemoveMarkqueueItem(index) {
      if (this.fields['markqueue-items'].length <= 1) return;
      this.fields['markqueue-items'].splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
